import { ExternalLink, Info } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { DeactivatePreflight } from '../../../../api/users';

import { buildImpactFromPreflight } from './deactivate-impact';
import DeactivateImpactCard from './DeactivateImpactCard';

interface DeactivateReviewBodyProps {
  preflight: DeactivatePreflight;
  /** Closes the modal before the operator follows the deep link away. */
  onNavigateAway: () => void;
}

export default function DeactivateReviewBody({
  preflight,
  onNavigateAway,
}: DeactivateReviewBodyProps) {
  const impact = buildImpactFromPreflight(preflight);
  return (
    <div className="px-[22px] pb-1">
      <DeactivateImpactCard rows={impact} />
      {preflight.upcomingWorkshopCount > 0 && (
        <Link
          to={preflight.deepLinkUrl}
          onClick={onNavigateAway}
          className="mt-2.5 inline-flex items-center gap-1.5 text-[12px] font-semibold text-moss-700 hover:text-moss-800"
        >
          Review workshops in the staff profile
          <ExternalLink size={12} />
        </Link>
      )}
      <div className="mt-3 px-3 py-2.5 text-[11.5px] leading-relaxed text-stone-600 dark:text-stone-400 flex gap-2 items-start">
        <Info size={14} className="flex-none mt-0.5" />
        <span>
          Deactivation does not auto-reassign. You can deactivate now and reassign later — the
          assignments stay in place but the user can no longer log in.
        </span>
      </div>
    </div>
  );
}
